import { render, staticRenderFns } from "./CreateSabbaticalRequestModal.vue?vue&type=template&id=64281e50&scoped=true&"
import script from "./CreateSabbaticalRequestModal.vue?vue&type=script&lang=js&"
export * from "./CreateSabbaticalRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateSabbaticalRequestModal.vue?vue&type=style&index=0&id=64281e50&lang=scss&scoped=true&"
import style1 from "./CreateSabbaticalRequestModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64281e50",
  null
  
)

export default component.exports